/**
 * Railway Monitoring API Service
 * Communicates with the BI Portal backend for Railway service monitoring.
 * Uses the authenticated axios instance from api.js.
 */

import api from './api';

const railwayApi = {
  /**
   * Get status of all Railway services and databases
   */
  getStatus: async () => {
    const response = await api.get('/railway/status');
    return response.data;
  },

  /**
   * Get deployment logs for a specific service
   * @param {string} serviceId - Railway service ID
   * @param {number} [limit=100] - Number of log lines to fetch
   */
  getServiceLogs: async (serviceId, limit = 100) => {
    const response = await api.get(`/railway/services/${serviceId}/logs`, {
      params: { limit },
    });
    return response.data;
  },

  /**
   * Restart the latest deployment of a service
   * @param {string} serviceId - Railway service ID
   */
  restartService: async (serviceId) => {
    const response = await api.post(`/railway/services/${serviceId}/restart`);
    return response.data;
  },

  /**
   * Trigger a new deployment for a service
   * @param {string} serviceId - Railway service ID
   */
  redeployService: async (serviceId) => {
    const response = await api.post(`/railway/services/${serviceId}/redeploy`);
    return response.data;
  },

  /**
   * Get database health status for MongoDB and PostgreSQL
   */
  getDatabaseHealth: async () => {
    const response = await api.get('/railway/health/databases');
    return response.data;
  },
};

export default railwayApi;

